import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, today, rp } from "@/lib/api";
import { PageHeader, Card, Table, Field, Sel, Money, StatusBadge } from "@/components/common";
import { Modal, SaveBtn, NewBtn } from "@/components/Modal";
import { PhotoUpload } from "@/components/PhotoUpload";
import { useAuth } from "@/context/AuthContext";

const CATS = ["Gaji", "Sewa", "Listrik & Air", "Gas", "Transportasi", "Perawatan", "Marketing", "Lain-lain"];

export default function Expenses() {
  const { meta, myLocs, myAccounts, can, loadMeta } = useAuth();
  const accounts = can("cash.manage") ? meta.cash_accounts : myAccounts;
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [photos, setPhotos] = useState([]);
  const outletLocs = myLocs.filter((l) => l.type === "outlet");
  const [f, setF] = useState({ date: today(), account_id: accounts[0]?.id, location_id: outletLocs[0]?.id, category: CATS[0], amount: "", note: "" });
  const load = () => api.get("/expenses").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);
  const save = async () => {
    try { await api.post("/expenses", { ...f, amount: Number(f.amount), photos: photos.map((p) => p.id) }); toast.success("Biaya dicatat"); setOpen(false); setPhotos([]); load(); loadMeta(); } catch (e) { toast.error(errMsg(e)); }
  };
  const reverse = async (e) => { try { await api.post(`/expenses/${e.id}/reverse`); toast.success("Biaya dibatalkan, kas dikembalikan"); load(); } catch (er) { toast.error(errMsg(er)); } };
  return (
    <div>
      <PageHeader title="Biaya outlet" sub="Biaya level outlet, dibayar dari kas outlet. Setiap biaya mengurangi saldo akun kas.">
        <NewBtn onClick={() => setOpen(true)} testid="new-expense-button">Catat biaya</NewBtn>
      </PageHeader>
      <Card>
        <Table testid="expenses-table" rows={rows} cols={[
          { h: "Kode", r: (r) => <span className="num text-xs font-semibold">{r.code}</span> }, { h: "Tanggal", k: "date" }, { h: "Lokasi", k: "location_name" },
          { h: "Kategori", k: "category" }, { h: "Akun", k: "account_name" }, { h: "Catatan", k: "note" },
          { h: "Jumlah", right: true, r: (r) => <Money v={r.amount} className="font-semibold" /> }, { h: "Oleh", r: (r) => r.created_by.name }, { h: "Status", r: (r) => <StatusBadge s={r.status} /> },
          { h: "", r: (r) => r.status === "posted" ? <button onClick={() => reverse(r)} className="text-xs text-rose-600 hover:underline" data-testid={`reverse-expense-${r.code}`}>Batalkan</button> : null },
        ]} />
      </Card>
      <Modal open={open} onOpenChange={setOpen} title="Catat biaya" testid="expense-modal">
        <div className="grid grid-cols-2 gap-3">
          <Field label="Tanggal"><input type="date" className="inp" value={f.date} onChange={(e) => setF({ ...f, date: e.target.value })} /></Field>
          <Field label="Kategori"><Sel value={f.category} onChange={(v) => setF({ ...f, category: v })} options={CATS.map((c) => ({ value: c, label: c }))} /></Field>
          <Field label="Outlet"><Sel testid="expense-location-select" value={f.location_id} onChange={(v) => setF({ ...f, location_id: v })} options={outletLocs.map((l) => ({ value: l.id, label: l.name }))} /></Field>
          <Field label="Akun kas"><Sel testid="expense-account-select" value={f.account_id} onChange={(v) => setF({ ...f, account_id: v })} options={accounts.map((a) => ({ value: a.id, label: `${a.name} (${rp(a.balance)})` }))} /></Field>
          <Field label="Jumlah (Rp)"><input className="inp num" type="number" value={f.amount} onChange={(e) => setF({ ...f, amount: e.target.value })} data-testid="expense-amount-input" /></Field>
          <Field label="Catatan"><input className="inp" value={f.note} onChange={(e) => setF({ ...f, note: e.target.value })} /></Field>
        </div>
        <PhotoUpload value={photos} onChange={setPhotos} label="Foto nota" testid="expense-photo" />
        <SaveBtn onClick={save} testid="expense-save-button" />
      </Modal>
    </div>
  );
}
